export const ITEM_FAVORITE_TYPE = {
	FAVORITE: 'favorite',
	SHARED: 'shared',
} as const;

export type TItemFavoriteType = typeof ITEM_FAVORITE_TYPE[keyof typeof ITEM_FAVORITE_TYPE];
